import { render, staticRenderFns } from "./DetalleUsuario.vue?vue&type=template&id=5c32c81f&scoped=true"
import script from "./DetalleUsuario.vue?vue&type=script&lang=js"
export * from "./DetalleUsuario.vue?vue&type=script&lang=js"
import style0 from "./DetalleUsuario.vue?vue&type=style&index=0&id=5c32c81f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32c81f",
  null
  
)

export default component.exports